import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

// Import translation files
import en from './locales/en.json';
import de from './locales/de.json';
import ja from './locales/ja.json';
import ru from './locales/ru.json';
import zh from './locales/zh.json';
import ar from './locales/ar.json';
import fr from './locales/fr.json'; // ✅ Add French

const resources = {
  en: { translation: en },
  de: { translation: de },
  ja: { translation: ja },
  ru: { translation: ru },
  zh: { translation: zh },
  ar: { translation: ar },
  fr: { translation: fr } // ✅ Add French
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: localStorage.getItem('language') || 'en',
    fallbackLng: 'en',
    interpolation: {
      escapeValue: false,
    },
  });

export default i18n;
